import { type } from 'arktype';
import type { AbsenceEntry, AbsenceSums, AbsenceTypeOption } from './absence-entry.model';
import type { VacationAccount } from './vacation-account.model';

export const absenceYearQuerySchema = type({
  year: type(/^\d{4}$/),
})
  .narrow((query, ctx) => {
    const year = Number(query.year);
    return (year >= 2000 && year <= 2100) || ctx.mustBe('a year between 2000 and 2100');
  })
  .onUndeclaredKey('reject');

export type AbsenceYearQueryInput = typeof absenceYearQuerySchema.t;

export interface AbsenceYearHoliday {
  date: string;
  name: string;
}

export type AbsenceMonthSums = Extract<AbsenceSums, { groupBy: 'month' }>;
export type AbsenceTypeSums = Extract<AbsenceSums, { groupBy: 'type' }>;

export interface MyWeekAbsenceYear {
  year: number;
  today: string;
  entries: AbsenceEntry[];
  holidays: AbsenceYearHoliday[];
  freeDays: string[];
  holidaysMissing: boolean;
  types: AbsenceTypeOption[];
  balance: VacationAccount | null;
  monthSums: AbsenceMonthSums;
  typeSums: AbsenceTypeSums;
}
